import slugify from 'slugify';

export const slug = slugify;

const replaceHTMLRegex = /<[^>]+>/g;
const replaceNonAlphaNumericRegex = /[^a-zA-Z0-9À-ž-\s]/g;
const slugGen = t => {
  if (t && /\S/.test(t)) {
      return slug(t.replace(replaceHTMLRegex, ''), {
          replacement: '-',
          remove: replaceNonAlphaNumericRegex,
          lower: true
      });
  }

  return null;
}


export const toSlug = t =>  slugGen(t) || "unknown";

export const slugifyName = t => slugGen(t) || "";

export function hrTimerToMilliseconds(timer) {
  return Math.round((timer[0] * 1e9 + timer[1]) / 1e6);
}

export function simpleStringCompare(a, b) {
  if (a > b) {
    return 1;
  }
  else if (a < b) {
    return -1;
  }
  else {
    return 0;
  }
}

export function isServer() {
  return typeof window === 'undefined' || typeof document === 'undefined';
}



// WEBPACK FOOTER //
// ./utils/index.js